import { CategoryService } from './../../core/services/category.service';
import { TeacherService } from './../../core/services/teacher.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Course } from '../../core/models/course';
import { BaseComponent } from 'src/app/components/base/base.component';
import { BaseService } from 'src/app/core/services/base.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Teacher } from '../../core/models/teacher';
import { CourseService } from '../../core/services/course.service';
import { Category } from '../../core/models/category';
import { Enrollment } from 'src/app/core/models/enrollment';
import { EnrollmentService } from 'src/app/core/services/enrollment.service';

@Component({
  selector: 'app-all-courses',
  templateUrl: './all-courses.component.html',
  styleUrls: ['./all-courses.component.scss']
})
export class AllCoursesComponent extends BaseComponent implements OnInit {

  courses: Course[];
  coursesNo: number = 0;
  teachers: Teacher[];
  categories: Category[];

  noCoursesForThisTeacherSection: boolean = false;
  p: number = 1;
  enrollment = {} as Enrollment;
  studentId: number;

  tokenValid = false;
  loader = true;
  isTeacher: string;
  favouriteCourses: Enrollment[];
  studFavs: any[];

  searchedResults: boolean = false;
  hidePagenation: boolean = false;



  @Input() currentPage: number = 1;
  @Input() itemsPerPage: number;
  @Input() totalItems: number;
  
  @Output() pageChanged: EventEmitter<number> = new EventEmitter();
  constructor(
    public baseService:BaseService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private courseService: CourseService,
    private enrollmentService: EnrollmentService,
    private teacherService: TeacherService,
    private categoryService :CategoryService
  ) { super() }

  ngOnInit(): void {
    debugger
    this.loadData();
    var studId = localStorage.getItem('studentId');
    this.studentId = Number(studId);

    this.courseService.getPagedCourses(1, 15).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.courses = data.result.returnData;
        this.loader = false;
        this.searchedResults = false
      }
    )

    this.courseService.getCoursesCount().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        // console.log(data.result.returnData)
        this.totalItems = data.result.returnData.courseCount
        // console.log(this.totalItems)
      }
    )

    // this.courseService.gets().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
    //   (data: any) => {
    //     this.courses = data.result.returnData;
    //     this.coursesNo = this.courses.length;

    //     console.log(this.courses)

    //     if (studId !== 'null') {
    //       this.enrollmentService.getStudentFav(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
    //         (data: any) => {
    //           this.favouriteCourses = data.result.returnData;

    //           this.studFavs = this.favouriteCourses.map(item => item.courseId);

    //           this.loader = false;
    //         }
    //       )
    //     }

    //     else if (studId === 'null') {
    //       this.loader = false;
    //     }

    //   }
    // )
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / 15);
  }

  changePage(page: number): void {
    debugger
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.pageChanged.emit(page);

      this.loader = true;
      this.courseService.getPagedCourses(page, 15).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          this.courses = data.result.returnData;
          window.scroll(0, 0);
          this.loader = false;
          this.searchedResults = false;
        }
      )
    }
  }

  loadData(){
    var loggedUser = localStorage.getItem('isTeacher');
    this.isTeacher = loggedUser;

    const token = localStorage.getItem('token');
    if (token) { this.tokenValid = true; }
    else { this.tokenValid = false; }


  }

  openDetail(id) {
    this.router.navigate(['/course-details/edit', id]);
  }

  viewTeacherProfile(id) {
    this.router.navigate(['/teacherprofile/edit', id]);
  }

  getTeacherId(e) {
    debugger
    this.loader = true;
    if(e.selectedItem === null) {
      this.courseService.getPagedCourses(1, 15).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          this.courses = data.result.returnData;
          this.loader = false;
          this.searchedResults = false;
        }
      )
    }
    else if (e.selectedItem !== null) {
      this.hidePagenation = true;
      this.courseService.getCourseByTeacherId(e.selectedItem.id).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          // console.log(data.result.returnData)
          if (data.result.returnData.length === 0) {
            this.loader = false;
            this.baseService.blockStop();
            this.noCoursesForThisTeacherSection = true;
            this.searchedResults = true;
          }
          else if (data.result.returnData.length !== 0) {
            this.loader = false;
            this.baseService.blockStop();
            this.noCoursesForThisTeacherSection = false;
            this.searchedResults = false;
            this.courses = data.result.returnData;
          }
        }
      )
    }
  }

  getCategoryId(e) {
    this.loader = true;
    this.baseService.blockStart();
    if(e.selectedItem === null) {
      this.courseService.getPagedCourses(1, 15).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          this.courses = data.result.returnData;
          this.loader = false;
          this.searchedResults = false;
        }
      )

      // this.courseService.gets().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      //   (data: any) => {
      //     this.loader = false;
      //     this.baseService.blockStop();
      //     this.courses = data.result.returnData;
      //   }
      // )
    }
    else if (e.selectedItem !== null) {
      this.hidePagenation = true;
      this.courseService.getCourseByCategoryId(e.selectedItem.id).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          // console.log(data.result.returnData)
          if (data.result.returnData.length === 0) {
            this.loader = false;
            this.baseService.blockStop();
            this.noCoursesForThisTeacherSection = true;
            this.searchedResults = true;
          }
          else if (data.result.returnData.length !== 0) {
            this.loader = false;
            this.baseService.blockStop();
            this.noCoursesForThisTeacherSection = false;
            this.searchedResults = true;
            this.courses = data.result.returnData;
          }
        }
      )
    }
  }

  getTeachers(e) {
    this.teacherService.gets().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.teachers = data.result.returnData;
      }
    )
  }

  getCategory(e) {
    this.categoryService.gets().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.categories = data.result.returnData;
      }
    )
  }


  addToFav(id) {
    debugger
    this.loader = true;
    this.enrollment.enrolled = false;
    this.enrollment.favorite = true;
    this.enrollment.studentId = this.studentId;
    this.enrollment.courseId = id;
    this.enrollmentService.enrollment(this.enrollment).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        if(data.result.message.type === 'Success') {
          var studId = localStorage.getItem('studentId');
          this.studentId = Number(studId);
          this.courseService.gets().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (data: any) => {
              this.courses = data.result.returnData;
              this.coursesNo = this.courses.length;
      
              if (studId !== 'null') {
                this.enrollmentService.getStudentFav(this.studentId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
                  (data: any) => {
                    this.favouriteCourses = data.result.returnData;
      
                    this.studFavs = this.favouriteCourses.map(item => item.courseId);
      
                    this.loader = false;
      
                    // console.log(this.courses);
                    // console.log(this.favouriteCourses);
                  }
                )
              }
      
              else if (studId === 'null') {
                this.loader = false;
              }
      
            }
          )
          this.alertService.success(this.translate.instant('addedToFavSucess'));
        }
      }
    )
  }
}
